var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20825 4H16.5833C17.8333 4 18.4583 4.625 18.4583 5.875V18.5312C18.4583 19.7812 17.8333 20.4062 16.5833 20.4062H7.20825C5.95825 20.4062 5.33325 19.7812 5.33325 18.5312V5.875C5.33325 4.625 5.95825 4 7.20825 4Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5833 5.875L16.5833 5.87501",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5833 7.28125L16.5833 7.28126",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00165 5.875V8.78125M8.61115 6.4618C8.34343 6.07991 7.32993 6.04 7.32993 6.70933C7.32993 7.37865 8.78898 7.05849 8.70474 7.8467C8.6345 8.50391 7.53662 8.51297 7.20825 7.98834",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5833 8.6875H16.5833",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20825 11.0312V18.0625",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20825 18.0625L16.5833 18.0625",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20825 12.4375H7.77075",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20825 13.8438H7.77075",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20825 15.25H7.77075",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20825 16.6562H7.77075",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27075 18.0625V17.5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3801 18.0625V17.5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4895 18.0625V17.5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5989 18.0625V17.5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7395 13.375H8.802C8.69845 13.375 8.6145 13.4589 8.6145 13.5625V16.7031C8.6145 16.8067 8.69845 16.8906 8.802 16.8906H9.7395C9.84306 16.8906 9.927 16.8067 9.927 16.7031V13.5625C9.927 13.4589 9.84306 13.375 9.7395 13.375Z",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8489 12.4375H10.9114C10.8078 12.4375 10.7239 12.5438 10.7239 12.675V16.6531C10.7239 16.7843 10.8078 16.8906 10.9114 16.8906H11.8489C11.9524 16.8906 12.0364 16.7843 12.0364 16.6531V12.675C12.0364 12.5438 11.9524 12.4375 11.8489 12.4375Z",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9583 10.6562H13.0208C12.9172 10.6562 12.8333 10.736 12.8333 10.8344V16.7125C12.8333 16.8109 12.9172 16.8906 13.0208 16.8906H13.9583C14.0618 16.8906 14.1458 16.8109 14.1458 16.7125V10.8344C14.1458 10.736 14.0618 10.6562 13.9583 10.6562Z",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0676 12.9062H15.1301C15.0266 12.9062 14.9426 12.9902 14.9426 13.0938V16.7031C14.9426 16.8067 15.0266 16.8906 15.1301 16.8906H16.0676C16.1712 16.8906 16.2551 16.8067 16.2551 16.7031V13.0938C16.2551 12.9902 16.1712 12.9062 16.0676 12.9062Z",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_2999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatements);
export default __webpack_public_path__ + "static/media/statements.d08a3e734efdbc3ea3d7373601e06e6a.svg";
export { ForwardRef as ReactComponent };